import { NEXT_PUBLIC_MAX_FILE_SIZE } from '@monoimin/constants';

export const isValidFileSize = (file: File) => {
  return file.size <= NEXT_PUBLIC_MAX_FILE_SIZE;
};
